import { calcResize } from 'components/Layout/styles';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

export const SContainer = styled(Container)``;

export const SSectionSlug = styled.span`
  font-weight: 500;
  text-transform: uppercase;
  color: ${props => props.theme.colors.accent};
  font-size: ${calcResize(12, 16)};
  letter-spacing: 4px;
`;

export const SSectionTitle = styled.h2`
  color: ${props =>
    props.inverted ? props.theme.colors.pastel_blue : props.theme.colors.main};

  margin-bottom: 25px;
  & .highlight {
    color: ${props => props.theme.colors.pastel_blue};
  }
`;
